import VuexPersistence from 'vuex-persist';
import { createStore } from 'vuex';

import users from './modules/users';
import meta from './modules/meta';
import materials from './modules/materials';
import contacts from './modules/contacts';
import transactions from './modules/transactions';
import expenses from './modules/expenses';
import reports from './modules/reports';

const vuexLocal = new VuexPersistence({
  key: 'lixo_do_bem',
  modules: ['users'],
  storage: window.localStorage,
  // options é guardado junto: carregado no login e reaproveitado entre sessões
  reducer: (state) => ({ users: state.users, meta: { options: state.meta.options } }),
});

export default createStore({
  modules: {
    users,
    meta,
    materials,
    contacts,
    transactions,
    expenses,
    reports
  },
  plugins: [vuexLocal.plugin]
});
